export enum DrawerList {
  // Quote Details
  Summary = 'Summary',
  Navigator = 'Quote Navigator',
  Subjectivities = 'Subjectivities',
  Underwriting = 'Underwriting',
  Tools = 'Tools',
  Messages = 'Messages',
  Notes = 'Notes',
  LayoutSettings = 'Display Preferences',
  RelatedTransactions = 'Related Transactions',
  // Help = 'Help & Resources',
  // Portal Admin
  Offering = 'Offering Management',
  Brokerage = 'Brokerage Management',
  User = 'User Management',
  Customer = 'Customer Management',
  Maintenance = 'Maintenance Mode',
  Alerts = 'Global Alerts',
  UWMgmt = 'Underwriting Management',
  QuoteSetupPresetManagement = 'URL Presets',
  LOIAvailability = 'LOI Availability',
  // settings
  UserProfile = 'My Profile',
  Notifications = 'Notification Preferences',
  PaymentMethods = 'Payment Settings',
  Payer = 'Payment Preferences',
  ManageSubjectivities = 'Manage Subjectivity Library',
  UnderwritingActivity = 'underwriting-activity',
  UnderwritingIssues = 'underwriting-issues',
  QuoteDetails = 'quoteDetails',
  TechnicalDetails = 'technicalDetails',
}
